import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './dishListBySlugQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto_MenuItemPosPhoto = {
  __typename: 'MenuItemPosPhoto',
  id: number,
  photoUrl?: string | null
};

export type DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto_Photo = {
  __typename: 'Photo',
  id: number,
  photoUrl?: string | null
};

export type DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto =
  | DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto_MenuItemPosPhoto
  | DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto_Photo
;

export type DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  city: string,
  countryName: string,
  state?: string | null
};

export type DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  name: string
};

export type DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  displayName: string,
  idAsSlug: string,
  popsCount: number,
  featuredPhoto?: DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem_featuredPhoto | null,
  location?: DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem_location_RestaurantLocation | null,
  restaurant: DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem_restaurant_Restaurant
};

export type DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler = {
  __typename: 'MenuItemPaginationHandler',
  count: number,
  hasMore: boolean,
  offset: number,
  records: Array<DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler_records_MenuItem>
};

export type DishListBySlugQuery_dishList_DishList = {
  __typename: 'DishList',
  id: number,
  categoryName?: string | null,
  description?: string | null,
  friendlySlug: string,
  name: string,
  photoUrl?: string | null,
  popsCount: number,
  slug: string,
  userAvatarUrl: string,
  userDisplayName: string,
  menuItems: DishListBySlugQuery_dishList_DishList_menuItems_MenuItemPaginationHandler
};

export type DishListBySlugQuery_Query = {
  __typename?: 'Query',
  dishList: DishListBySlugQuery_dishList_DishList
};


export type DishListBySlugQueryVariables = Types.Exact<{
  pagination: Types.PaginationInput;
  slug: Types.Scalars['String']['input'];
}>;


export type DishListBySlugQuery = DishListBySlugQuery_Query;


export const DishListBySlugDocument = /*#__PURE__*/ document as unknown as DocumentNode<DishListBySlugQuery, DishListBySlugQueryVariables>;


/**
 * __useDishListBySlugQuery__
 *
 * To run a query within a React component, call `useDishListBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useDishListBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDishListBySlugQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useDishListBySlugQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DishListBySlugQuery, DishListBySlugQueryVariables> & ({ variables: DishListBySlugQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DishListBySlugQuery, DishListBySlugQueryVariables>(DishListBySlugDocument, options);
      }
export function useDishListBySlugLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DishListBySlugQuery, DishListBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DishListBySlugQuery, DishListBySlugQueryVariables>(DishListBySlugDocument, options);
        }
// @ts-ignore
export function useDishListBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DishListBySlugQuery, DishListBySlugQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DishListBySlugQuery, DishListBySlugQueryVariables>;
export function useDishListBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DishListBySlugQuery, DishListBySlugQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DishListBySlugQuery | undefined, DishListBySlugQueryVariables>;
export function useDishListBySlugSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DishListBySlugQuery, DishListBySlugQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DishListBySlugQuery, DishListBySlugQueryVariables>(DishListBySlugDocument, options);
        }
export type DishListBySlugQueryHookResult = ReturnType<typeof useDishListBySlugQuery>;
export type DishListBySlugLazyQueryHookResult = ReturnType<typeof useDishListBySlugLazyQuery>;
export type DishListBySlugSuspenseQueryHookResult = ReturnType<typeof useDishListBySlugSuspenseQuery>;
export type DishListBySlugQueryResult = ApolloReactCommon.QueryResult<DishListBySlugQuery, DishListBySlugQueryVariables>;